import request from 'common/request';
import { ACTION_TYPES } from '../../../constants';

export function putAssessmentLock(candidateId, lock) {
  return (dispatch) => {
    dispatch(postLoginUserFailure(''));
    request
      .put(`/login/${candidateId}/assessment-lock`, { lock })
      .then(function (response) {
        const { redirect, message } = response.data;
        if (message) {
          dispatch(postLoginUserFailure(message));
        } else if (redirect) {
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  };
}

function postLoginUserFailure(message) {
  return {
    type: ACTION_TYPES.LOGIN.FAILURE,
    payload: {
      message: message,
    },
  };
}



// WEBPACK FOOTER //
// ./src/pages/login/components/loginForm/actions/putAssessmentLock.js